import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyBCnSPKMgQeV7mktHaZdcDq121dWj2i6zk",
  authDomain: "e-analogy-279118.firebaseapp.com",
  databaseURL: "https://e-analogy-279118.firebaseio.com",
  projectId: "e-analogy-279118",
  storageBucket: "e-analogy-279118.appspot.com",
  messagingSenderId: "673810731969",
  appId: "1:673810731969:web:1c85d5fe7f084fa0dd9540",
  measurementId: "G-QNHZ8H9CSC",
};
// Initialize Firebase
const isLive = location.hostname == "alpine-leasing.web.app";
firebase.initializeApp(firebaseConfig);
const functions = firebase.functions();
if (location.hostname == "localhost") {
  functions.useFunctionsEmulator("http://localhost:5001");
}
const fs = firebase.firestore();
const db = firebase.database().ref();
const listings = fs.collection("listings");
const auth = firebase.auth();
export { functions, auth, fs, db, listings, isLive };
